module.exports = __webpack_public_path__ + "static/media/SuperShuttle_web_2_preview.899dbacd.jpg";